
import axios from 'axios';
import { APIOverrides } from '../../ApiOverrides';
import type { CategoryProps, LeaderProps, PublicPlayerProps, TimerangeProps } from '../../types';

let AUTH_SVC_API = ''
const ANALYTICS_SVC_API = 'https://be-analytics-svc.herokuapp.com';


export const LeadersApi = {
    setEnvironment: () => {
        const endpoints = APIOverrides.getEndpoints();
        AUTH_SVC_API = endpoints['AUTH_SVC_API'] as string;
    },
    getLeaders : async(category_id:string, timerange_id:string, offset:number, viewer_id?:string):Promise<undefined | { leaders:LeaderProps[], timerange:TimerangeProps, category:CategoryProps }> => {
        try {
            const resp = await axios.get(`${ANALYTICS_SVC_API}/v1/leaders/category/${category_id}?timerange_id=${timerange_id}&offset=${offset}&player_id=${viewer_id}`)
            const { leaders, timerange, category } = resp.data
            return { leaders, timerange, category }   
        } catch (e) {
            return undefined
        }
    },
    getCategories : async():Promise<{categories: CategoryProps[], time_ranges:TimerangeProps[]}> => {
        try {
            const resp = await axios.get(`${ANALYTICS_SVC_API}/v1/leaders/categories/all?status=active`)
            return { categories: resp.data.categories, time_ranges: resp.data.time_ranges }
        } catch (e) {
            return { categories:[], time_ranges: [] }
        }
    },
    getPlayersByPlayerIds : async(player_ids:string[]):Promise<PublicPlayerProps[]> => {
        try {
            if(player_ids.length == 0){ return [] }
            const resp = await axios.post(`${AUTH_SVC_API}/v1/players/bulk/get`, { player_ids })
            return resp.data.players
        } catch (e) {
            return []
        }   
    }
}


export const LeadersHelpers = {
    formatPlace :(place:number) => {
        switch(place){
            case 1:
                return '1st'
            case 2:
                return '2nd'
            case 3:
                return '3rd'
            case 4:
                return '4th'
            case 5:
                return '5th'
            case 6:
                return '6th'
            case 7:
                return '7th'
            case 8:
                return '8th'
            case 9:
                return '9th'
            default:
                return `${place}`
    
        }
    },
}